module.exports = __webpack_public_path__ + "static/media/ge-bottom-banner.acfdfac4.png";